AFRAME.registerComponent('left-panel-2', {
    schema: {},

    init: function () {
        this.themeMode = 'Dark';
        const mainSettings = getCacheItem('mainSettings');
        if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
            this.themeMode = mainSettings.themeMode;
        } else {
            const parsed = getCacheItem('configureControlSettings');
            if (parsed && (parsed.themeMode === 'Light' || parsed.themeMode === 'Dark')) {
                this.themeMode = parsed.themeMode;
            }
        }
        this.mainContentColor = '#fff';
        this.bgPanelLight = this.el.querySelector('.background-panel-light');
        this.bgPanelDark = this.el.querySelector('.background-panel-dark');
        this.bgModel = this.el.querySelector('.bg-model');
        this.applyTheme();

        this.scene = document.querySelector('a-scene');

        this.screen1 = this.el.querySelector('#news-screen-1');
        this.screen2 = this.el.querySelector('#news-screen-2');
        this.currentNews = null;

        this.headerElementS1 = this.el.querySelector('#news-screen-1 .left-panel-2-header');
        this.headerElementS2 = this.el.querySelector('#news-screen-2 .left-panel-2-header');
        this.contentElementS2 = this.el.querySelector('#news-screen-2  .left-panel-2-content');
        if (!this.headerElementS1 || !this.headerElementS2 || !this.contentElementS2) return;
        this.contentElementS1 = this.el.querySelector('#news-screen-1  .left-panel-2-content');
        if (!this.contentElementS1) return;

        this.currentMode = 'market-summary';
        this.currentPage = 0;
        this.totalPages = 1;
        this.rawItems = [];
        this.rawPayload = null;
        this.priceMap = null;
        this.noArticles = false;

        this.createNewsPanel();

        this.scene.addEventListener('update-news-data-3d', this.onNewsData3D.bind(this));
        this.scene.addEventListener('theme-changed', this.updateTheme.bind(this));

        this.scene.addEventListener('chart-type-changed', (e) => {
            const action = e.detail?.action;
            if (action && action !== 'watchlist-reports') {
                this.scene.emit('news-filter-changed', { filter: 'market-summary' });
            }
            this.updateNewsGraphControlButton();
        });

        this.scene.addEventListener('news-graph-autorotate-changed', () => {
            this.updateNewsGraphControlButton();
        });

        this.scene.addEventListener('news-filter-changed', (e) => {
            const filter = e.detail?.filter;
            if (filter && filter !== 'news-graph') {
                if (this.screen1) {
                    this.screen1.setAttribute('visible', 'true');
                    this.screen1.setAttribute('position', '0 0 0.02');
                }
                if (this.screen2) {
                    this.screen2.setAttribute('visible', 'false');
                    this.screen2.setAttribute('position', '0 6 0');
                }
                const leftOverview = this.el.querySelector('#news-graph-overview-vr-left');
                if (leftOverview) {
                    leftOverview.setAttribute('visible', 'false');
                }
            }
            this.updateNewsGraphControlButton();
        });
    },

    applyTheme: function () {
        if (this.themeMode === 'Dark') {
            if (this.bgPanelLight) this.bgPanelLight.setAttribute('visible', false);
            if (this.bgPanelDark) this.bgPanelDark.setAttribute('visible', true);
            if (this.bgModel) this.bgModel.setAttribute('visible', 'true');
            this.mainContentColor = '#fff';
        } else {
            if (this.bgPanelDark) this.bgPanelDark.setAttribute('visible', false);
            if (this.bgPanelLight) this.bgPanelLight.setAttribute('visible', true);
            if (this.bgModel) this.bgModel.setAttribute('visible', 'false');
            this.mainContentColor = '#111';
        }
    },

    createNewsPanel: function () {
        this.titleTextS1 = document.createElement('a-text');
        this.titleTextS1.setAttribute('value', 'News');
        this.titleTextS1.setAttribute('color', this.mainContentColor);
        this.titleTextS1.setAttribute('scale', '0.25 0.25 0.25');
        this.titleTextS1.setAttribute('anchor', 'left');
        this.titleTextS1.setAttribute('position', `0 0 0.01`);
        this.contentElementS1.appendChild(this.titleTextS1);

        this.tickerPriceContainer = document.createElement('a-entity');
        this.tickerPriceContainer.setAttribute('position', '0.38 0 0.01');
        this.tickerPriceContainer.setAttribute('visible', 'false');

        this.tickerPriceText = document.createElement('a-text');
        this.tickerPriceText.setAttribute('value', '');
        this.tickerPriceText.setAttribute('color', this.mainContentColor);
        this.tickerPriceText.setAttribute('scale', '0.22 0.22 0.22');
        this.tickerPriceText.setAttribute('anchor', 'left');
        this.tickerPriceText.setAttribute('position', '0 0 0');
        this.tickerPriceContainer.appendChild(this.tickerPriceText);

        this.tickerChangeText = document.createElement('a-text');
        this.tickerChangeText.setAttribute('value', '');
        this.tickerChangeText.setAttribute('color', '#aaaaaa');
        this.tickerChangeText.setAttribute('scale', '0.22 0.22 0.22');
        this.tickerChangeText.setAttribute('anchor', 'left');
        this.tickerChangeText.setAttribute('position', '0 -0.055 0');
        this.tickerPriceContainer.appendChild(this.tickerChangeText);

        this.contentElementS1.appendChild(this.tickerPriceContainer);

        const filterContainer = document.createElement('a-entity');
        filterContainer.setAttribute('position', '0 -0.07 0.02');

        const btnWidth = 0.44;
        const btnHeight = 0.08;
        const btnDepth = 0.02;
        const btnRadius = 0.015;
        const btnFontSize = 0.035;

        // Button 1: Market Summary
        this.marketSummaryBtn = document.createElement('a-entity');
        this.marketSummaryBtn.setAttribute('ui-button', {
            label: 'Market Summary',
            width: btnWidth,
            height: btnHeight,
            depth: btnDepth,
            radius: btnRadius,
            colorScheme: 'primary',
            selected: true,
            type: 'rounded-box',
            preferredFontSize: btnFontSize
        });
        this.marketSummaryBtn.setAttribute('position', `-0.24 0.05 0`);
        this.marketSummaryBtn.addEventListener('click', () => {
             this.scene.emit('news-filter-changed', { filter: 'market-summary' });
             if (window.gtag) gtag('event', 'VR_LeftPanel_MarketSummary');
        });
        filterContainer.appendChild(this.marketSummaryBtn);

        this.businessHeadlinesBtn = document.createElement('a-entity');
        this.businessHeadlinesBtn.setAttribute('ui-button', {
            label: 'Business Headlines',
            width: btnWidth,
            height: btnHeight,
            depth: btnDepth,
            radius: btnRadius,
            colorScheme: 'primary',
            type: 'rounded-box',
            preferredFontSize: btnFontSize
        });
        this.businessHeadlinesBtn.setAttribute('position', `0.24 0.05 0`);
        this.businessHeadlinesBtn.addEventListener('click', () => {
             this.scene.emit('news-filter-changed', { filter: 'business-headlines' });
             if (window.gtag) gtag('event', 'VR_LeftPanel_BusinessHeadlines');
        });
        filterContainer.appendChild(this.businessHeadlinesBtn);

        this.trendingStockBtn = document.createElement('a-entity');
        this.trendingStockBtn.setAttribute('ui-button', {
            label: 'Trending Stock',
            width: btnWidth,
            height: btnHeight,
            depth: btnDepth,
            radius: btnRadius,
            colorScheme: 'primary',
            type: 'rounded-box',
            preferredFontSize: btnFontSize
        });
        this.trendingStockBtn.setAttribute('position', `-0.24 -0.05 0`);
        this.trendingStockBtn.addEventListener('click', () => {
             this.scene.emit('news-filter-changed', { filter: 'trending-stock' });
             if (window.gtag) gtag('event', 'VR_LeftPanel_TrendingStock');
        });
        filterContainer.appendChild(this.trendingStockBtn);

        this.watchlistNewsBtn = document.createElement('a-entity');
        this.watchlistNewsBtn.setAttribute('ui-button', {
            label: 'Watchlist News',
            width: btnWidth,
            height: btnHeight,
            depth: btnDepth,
            radius: btnRadius,
            colorScheme: 'primary',
            type: 'rounded-box',
            preferredFontSize: btnFontSize
        });
        this.watchlistNewsBtn.setAttribute('position', `0.24 -0.05 0`);
        this.watchlistNewsBtn.addEventListener('click', () => {
             this.scene.emit('news-filter-changed', { filter: 'watchlist-news' });
             if (window.gtag) gtag('event', 'VR_LeftPanel_WatchlistNews');
        });
        filterContainer.appendChild(this.watchlistNewsBtn);

        this.headerElementS1.appendChild(filterContainer);

        this.el.sceneEl.addEventListener('set-news-filter-ui', (evt) => {
            if (evt.detail && evt.detail.filter) {
                this.setFilter(evt.detail.filter);
            }
        });

        this.graphBtnContainer = document.createElement('a-entity');
        this.graphBtnContainer.setAttribute('position', `0 -1.75 0.02`);

        this.newsGraphControlBtn = document.createElement('ui-button');
        this.newsGraphControlBtn.setAttribute('label', 'News Graph');
        this.newsGraphControlBtn.setAttribute('type', 'rounded-box');
        this.newsGraphControlBtn.setAttribute('width', 1.0);
        this.newsGraphControlBtn.setAttribute('height', 0.12);
        this.newsGraphControlBtn.setAttribute('depth', 0.01);
        this.newsGraphControlBtn.setAttribute('radius', 0.02);
        this.newsGraphControlBtn.setAttribute('color-scheme', 'accent');
        this.newsGraphControlBtn.setAttribute('preferred-font-size', 0.04);
        this.newsGraphControlBtn.setAttribute('hover-scale', 1);

        this.newsGraphControlBtn.addEventListener('click', () => {
            if (this.isNewsGraphActive()) {
                return;
            }

            if (window.gtag) gtag('event', 'VR_LeftPanel_NewsGraphBtn');
            const centerContent = document.getElementById('large-center-panel-content');
            if (centerContent) {
                centerContent.replaceChildren();
                centerContent.setAttribute('position', '0 0 0');
            }
            if (window.renderStockChartByAction) {
                window.renderStockChartByAction('news-graph', 'gen');
            }
            const scene = document.querySelector('a-scene');
            if (scene) {
                scene.emit('chart-type-changed', { action: 'news-graph' });
            }

            this.updateNewsGraphControlButton();
            setTimeout(() => this.updateNewsGraphControlButton(), 120);
            setTimeout(() => this.updateNewsGraphControlButton(), 420);
        });
        this.graphBtnContainer.appendChild(this.newsGraphControlBtn);
        this.headerElementS1.appendChild(this.graphBtnContainer);
        this.updateNewsGraphControlButton();

        const backButtonContainer = document.createElement('a-entity');
        backButtonContainer.setAttribute('position', `-0.5 -0.1 0.01`);

        const backButton = document.createElement('ui-button');
        backButton.setAttribute('type', 'rounded-box');
        backButton.setAttribute('image', '#back-button');
        backButton.setAttribute('width', 0.1);
        backButton.setAttribute('height', 0.1);
        backButton.setAttribute('depth', 0.01);
        backButton.setAttribute('radius', 0.02);
        backButton.setAttribute('color-scheme', 'primary');
        backButtonContainer.appendChild(backButton);

        this.headerElementS2.appendChild(backButtonContainer);
        backButton.addEventListener('click', () => {
            this.screen1.setAttribute('visible', 'true');
            this.screen1.setAttribute('position', '0 0 0.02');
            this.screen2.setAttribute('visible', 'false');
            this.screen2.setAttribute('position', '0 6 0');
        });

        const title2 = document.createElement('a-text');
        title2.setAttribute('value', 'News Details');
        title2.setAttribute('color', this.mainContentColor);
        title2.setAttribute('scale', '0.25 0.25 0.25');
        title2.setAttribute('anchor', 'left');
        title2.setAttribute('position', `0 -0.1 0.001`);
        this.headerElementS2.appendChild(title2);
    },

    isNewsGraphActive: function () {
        return document.body.classList.contains('news-graph-active');
    },

    getNewsGraphRotationComponent: function () {
        const wrapper = document.getElementById('news-graph-wrapper');
        if (!wrapper || !wrapper.components) return null;
        return wrapper.components['news-graph-rotation'] || null;
    },

    updateNewsGraphControlButton: function () {
        if (!this.newsGraphControlBtn) return;
        this.newsGraphControlBtn.setAttribute('ui-button', 'label', 'News Graph');
    },

    onNewsData3D: function (evt) {
        const detail = evt.detail;
        this.currentMode = detail.mode;
        this.ticker = detail.ticker;
        this.rawItems = detail.items || [];
        this.rawPayload = detail.rawPayload;
        this.priceMap = detail.priceMap;
        this.noArticles = detail.noArticles;
        this.watchlistName = detail.watchlistName || '';
        this.tickerSymbol = detail.tickerSymbol || '';
        this.exchange = detail.exchange || '';

        this.currentPage = 0;
        this.totalPages = Math.max(1, Math.ceil(this.rawItems.length / 4));

        this.setFilter(this.currentMode);

        let titleVal = 'News';
        if (this.currentMode === 'ticker-news' && this.tickerSymbol) {
            titleVal = `${this.tickerSymbol} News`;
        } else if (this.currentMode === 'watchlist-news') {
            titleVal = `${this.watchlistName || 'Watchlist'} News`;
        } else if (this.currentMode === 'market-summary') {
            titleVal = 'Market Summary';
        } else if (this.currentMode === 'business-headlines') {
            titleVal = 'Business Headlines';
        } else if (this.currentMode === 'trending-stock') {
            titleVal = 'Trending Stock';
        }
        if (this.titleTextS1) {
            this.titleTextS1.setAttribute('value', titleVal);
            this.titleTextS1.setAttribute('color', this.mainContentColor);
        }

        if (this.tickerPriceContainer && this.tickerPriceText && this.tickerChangeText) {
            if (this.currentMode === 'ticker-news' && this.tickerSymbol) {
                const sym = this.tickerSymbol.toUpperCase();
                const entry = (this.priceMap ? this.priceMap.get(sym) : null) || null;
                const latestPrice = entry?.price ?? null;
                const changePct = entry?.changePct ?? null;

                const priceStr = (latestPrice !== null && Number.isFinite(latestPrice))
                    ? `$${latestPrice.toFixed(2)}`
                    : 'N/A';
                this.tickerPriceText.setAttribute('value', priceStr);
                this.tickerPriceText.setAttribute('color', this.mainContentColor);

                const sign = (changePct !== null && changePct >= 0) ? '+' : '';
                const pctStr = changePct !== null ? `${sign}${changePct.toFixed(2)}%` : 'N/A';
                const changeColor = changePct !== null
                    ? (changePct >= 0 ? '#00cc66' : '#ff4444')
                    : '#888888';
                this.tickerChangeText.setAttribute('value', pctStr);
                this.tickerChangeText.setAttribute('color', changeColor);

                this.tickerPriceContainer.setAttribute('visible', 'true');
            } else {
                this.tickerPriceContainer.setAttribute('visible', 'false');
            }
        }

        this.renderCurrentPage();
    },

    renderCurrentPage: function () {
        while (this.contentElementS1.children.length > 2) {
            this.contentElementS1.removeChild(this.contentElementS1.lastChild);
        }

        const sourcesPanel = this.el.querySelector('#news-graph-sources-vr');
        const isSourcesVisible = sourcesPanel && (sourcesPanel.getAttribute('visible') === true || sourcesPanel.getAttribute('visible') === 'true');

        if (this.isNewsGraphActive() && isSourcesVisible) {
            this.screen1.setAttribute('visible', 'false');
            this.screen1.setAttribute('position', '0 6 0');
            this.screen2.setAttribute('visible', 'false');
            this.screen2.setAttribute('position', '0 6 0');
        } else {
            this.screen1.setAttribute('visible', 'true');
            this.screen1.setAttribute('position', '0 0 0.02');
            this.screen2.setAttribute('visible', 'false');
            this.screen2.setAttribute('position', '0 6 0');
        }

        if (this.noArticles || !this.rawItems || this.rawItems.length === 0) {
            let msg = 'No data available.';
            if (this.currentMode === 'watchlist-news') {
                msg = 'Please log in to view watchlist news.';
            } else if (this.currentMode === 'ticker-news') {
                msg = `No articles found for ${this.tickerSymbol || 'selected ticker'}.`;
            }
            this.informNoArticles(msg);
            return;
        }

        const start = this.currentPage * 4;
        const end = start + 4;
        const pageItems = this.rawItems.slice(start, end);

        const itemHeight = 0.28;
        const titleRowHeight = 0.14;

        pageItems.forEach((item, index) => {
            const y = -(titleRowHeight + index * itemHeight);
            if (this.currentMode === 'market-summary') {
                this.createMarketSummaryItem(item, y);
            } else if (this.currentMode === 'business-headlines') {
                this.createBusinessHeadlineItem(item, y);
            } else if (this.currentMode === 'trending-stock') {
                this.createTrendingStockItem(item, y);
            } else {
                this.createArticleItem(item, y);
            }
        });

        this.renderPagination();
    },

    informNoArticles: function(value) {
        const noArticlesElem = document.createElement('a-text');
        noArticlesElem.setAttribute('value', value);
        noArticlesElem.setAttribute('scale', '0.2 0.2 0.2');
        noArticlesElem.setAttribute('align', 'left');
        noArticlesElem.setAttribute('anchor', 'left');
        noArticlesElem.setAttribute('position', `0 -0.1 0.01`);
        noArticlesElem.setAttribute('color', this.mainContentColor);
        this.contentElementS1.appendChild(noArticlesElem);
    },

    createMarketSummaryItem: function (n, y) {
        const itemContainer = document.createElement('a-entity');
        itemContainer.setAttribute('position', `0 ${y} 0.01`);

        // Title
        let rawTitle = this.decodeHtmlEntities(n.title || '');
        if (rawTitle.length > 55) rawTitle = rawTitle.slice(0, 52) + '...';
        const titleElem = document.createElement('a-text');
        titleElem.setAttribute('value', rawTitle);
        titleElem.setAttribute('color', this.mainContentColor);
        titleElem.setAttribute('scale', '0.23 0.23 0.23');
        titleElem.setAttribute('width', 3.5);
        titleElem.setAttribute('wrap-count', 28);
        titleElem.setAttribute('line-height', 60);
        titleElem.setAttribute('anchor', 'left');
        titleElem.setAttribute('baseline', 'top');
        titleElem.setAttribute('position', `0 -0.02 0.001`);
        itemContainer.appendChild(titleElem);

        const dir = (n.direction || 'neutral').toLowerCase();
        const dirLabel = dir.charAt(0).toUpperCase() + dir.slice(1);
        const badgeBg = document.createElement('a-rounded-plane');
        badgeBg.setAttribute('width', 0.16);
        badgeBg.setAttribute('height', 0.06);
        badgeBg.setAttribute('radius', 0.01);
        const badgeColor = dir === 'bullish' || dir === 'positive' || dir === 'up' ? '#00aa00'
                         : dir === 'bearish' || dir === 'negative' || dir === 'down' ? '#cc0000'
                         : '#555555';
        badgeBg.setAttribute('color', badgeColor);
        badgeBg.setAttribute('position', `0 -0.21 0.001`);

        const badgeText = document.createElement('a-text');
        badgeText.setAttribute('value', dirLabel);
        badgeText.setAttribute('color', '#fff');
        badgeText.setAttribute('scale', '0.15 0.15 0.15');
        badgeText.setAttribute('align', 'center');
        badgeText.setAttribute('baseline', 'center');
        badgeText.setAttribute('position', `0.08 0.03 0.001`);
        badgeBg.appendChild(badgeText);
        itemContainer.appendChild(badgeBg);

        const count = n.article_count || 0;
        const sourceText = document.createElement('a-text');
        sourceText.setAttribute('value', `${count} source${count !== 1 ? 's' : ''}`);
        sourceText.setAttribute('color', this.mainContentColor);
        sourceText.setAttribute('scale', '0.18 0.18 0.18');
        sourceText.setAttribute('anchor', 'left');
        sourceText.setAttribute('opacity', 0.6);
        sourceText.setAttribute('position', `0.20 -0.18 0.001`);
        itemContainer.appendChild(sourceText);

        const detailsBtn = document.createElement('a-entity');
        detailsBtn.setAttribute('position', `0.95 -0.18 0.002`);
        detailsBtn.setAttribute('ui-button', {
            label: 'Details',
            width: 0.22,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.01,
            preferredFontSize: 0.03
        });
        detailsBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openNarrativeDetail(n);
        });
        itemContainer.appendChild(detailsBtn);

        const clickArea = document.createElement('a-plane');
        clickArea.setAttribute('width', 0.85);
        clickArea.setAttribute('height', 0.16);
        clickArea.setAttribute('material', 'transparent: true; opacity: 0; depthWrite: false;');
        clickArea.setAttribute('data-raycastable', '');
        clickArea.setAttribute('position', `0.425 -0.08 0.001`);
        clickArea.addEventListener('click', () => this.openNarrativeDetail(n));
        clickArea.addEventListener('mouseenter', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: '#6C6CFF', dur: 200, easing: 'easeInOutQuad' });
        });
        clickArea.addEventListener('mouseleave', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: this.mainContentColor, dur: 200, easing: 'easeInOutQuad' });
        });
        itemContainer.appendChild(clickArea);

        this.contentElementS1.appendChild(itemContainer);
    },

    createBusinessHeadlineItem: function (a, y) {
        const itemContainer = document.createElement('a-entity');
        itemContainer.setAttribute('position', `0 ${y} 0.01`);

        const sourceName = this.cleanSourceName(a.source, a.url);
        const dateStr = a.published_at ? new Date(a.published_at).toLocaleDateString() : '';

        const metaText = document.createElement('a-text');
        metaText.setAttribute('value', `${sourceName} • ${dateStr}`);
        metaText.setAttribute('color', this.mainContentColor);
        metaText.setAttribute('scale', '0.16 0.16 0.16');
        metaText.setAttribute('anchor', 'left');
        metaText.setAttribute('opacity', 0.6);
        metaText.setAttribute('position', `0 0 0.001`);
        itemContainer.appendChild(metaText);

        const titleElem = document.createElement('a-text');
        let rawTitle = this.decodeHtmlEntities(a.title || '');
        if (rawTitle.length > 52) {
            rawTitle = rawTitle.slice(0, 52) + '...';
        }
        titleElem.setAttribute('value', rawTitle);
        titleElem.setAttribute('color', this.mainContentColor);
        titleElem.setAttribute('scale', '0.23 0.23 0.23');
        titleElem.setAttribute('width', 3.5);
        titleElem.setAttribute('wrap-count', 28);
        titleElem.setAttribute('line-height', 60);
        titleElem.setAttribute('anchor', 'left');
        titleElem.setAttribute('baseline', 'top');
        titleElem.setAttribute('position', `0 -0.04 0.001`);
        itemContainer.appendChild(titleElem);

        const rawSent = (a.sentiment || 'neutral').toLowerCase();
        const sentimentClass = rawSent === 'positive' ? 'Bullish'
                             : rawSent === 'negative' ? 'Bearish'
                             : 'Neutral';
        const badgeBg = document.createElement('a-rounded-plane');
        badgeBg.setAttribute('width', 0.16);
        badgeBg.setAttribute('height', 0.06);
        badgeBg.setAttribute('radius', 0.01);
        const badgeColor = sentimentClass === 'Bullish' ? '#00aa00'
                         : sentimentClass === 'Bearish' ? '#cc0000'
                         : '#555555';
        badgeBg.setAttribute('color', badgeColor);
        badgeBg.setAttribute('position', `0 -0.25 0.001`);

        const badgeText = document.createElement('a-text');
        badgeText.setAttribute('value', sentimentClass);
        badgeText.setAttribute('color', '#fff');
        badgeText.setAttribute('scale', '0.15 0.15 0.15');
        badgeText.setAttribute('align', 'center');
        badgeText.setAttribute('baseline', 'center');
        badgeText.setAttribute('position', `0.08 0.03 0.001`);
        badgeBg.appendChild(badgeText);
        itemContainer.appendChild(badgeBg);

        const detailsBtn = document.createElement('a-entity');
        detailsBtn.setAttribute('position', `0.95 -0.18 0.002`);
        detailsBtn.setAttribute('ui-button', {
            label: 'Read',
            width: 0.22,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.01,
            preferredFontSize: 0.03
        });
        detailsBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openArticleDetail(a);
        });
        itemContainer.appendChild(detailsBtn);

        const clickArea = document.createElement('a-plane');
        clickArea.setAttribute('width', 0.85);
        clickArea.setAttribute('height', 0.16);
        clickArea.setAttribute('material', 'transparent: true; opacity: 0; depthWrite: false;');
        clickArea.setAttribute('data-raycastable', '');
        clickArea.setAttribute('position', `0.425 -0.08 0.001`);
        clickArea.addEventListener('click', () => this.openArticleDetail(a));
        clickArea.addEventListener('mouseenter', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: '#6C6CFF', dur: 200, easing: 'easeInOutQuad' });
        });
        clickArea.addEventListener('mouseleave', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: this.mainContentColor, dur: 200, easing: 'easeInOutQuad' });
        });
        itemContainer.appendChild(clickArea);

        this.contentElementS1.appendChild(itemContainer);
    },

    createTrendingStockItem: function (t, y) {
        const itemContainer = document.createElement('a-entity');
        itemContainer.setAttribute('position', `0 ${y} 0.01`);

        const syms = t.grouped_tickers || [t.symbol];
        const symbolsDisplay = syms.length <= 3 ? syms.join(' + ') : `${syms.slice(0, 2).join(' + ')} +${syms.length - 2}`;

        const nameVal = (t.group_label || t.name || t.symbol || '');
        const titleVal = `${nameVal} (${symbolsDisplay})`;

        const titleElem = document.createElement('a-text');
        let rawTitle = this.decodeHtmlEntities(titleVal);
        if (rawTitle.length > 31) {
            rawTitle = rawTitle.slice(0, 28) + '...';
        }
        titleElem.setAttribute('value', rawTitle);
        titleElem.setAttribute('color', this.mainContentColor);
        titleElem.setAttribute('scale', '0.23 0.23 0.23');
        titleElem.setAttribute('width', 3.5);
        titleElem.setAttribute('wrap-count', 32);
        titleElem.setAttribute('line-height', 60);
        titleElem.setAttribute('anchor', 'left');
        titleElem.setAttribute('baseline', 'top');
        titleElem.setAttribute('position', `0 -0.02 0.001`);
        itemContainer.appendChild(titleElem);

        let currentX = 0;
        syms.slice(0, 3).forEach(sym => {
            const cleanSym = String(sym).toUpperCase();
            const entry = this.priceMap ? this.priceMap.get(cleanSym) : null;
            const changePct = entry?.changePct ?? null;
            const isPreIpo = this.isPreIpoSymbol(cleanSym);

            const pillBg = document.createElement('a-rounded-plane');
            pillBg.setAttribute('height', 0.05);
            pillBg.setAttribute('radius', 0.008);

            const pillText = document.createElement('a-text');
            pillText.setAttribute('color', '#fff');
            pillText.setAttribute('scale', '0.12 0.12 0.12');
            pillText.setAttribute('align', 'center');
            pillText.setAttribute('baseline', 'center');

            let label = cleanSym;
            let bgColor = '#555555';
            let pillWidth = 0.12;

            if (isPreIpo) {
                label = `${cleanSym} (Pre-IPO)`;
                bgColor = '#444444';
                pillWidth = 0.22;
            } else if (changePct !== null) {
                const sign = changePct >= 0 ? '+' : '';
                label = `${cleanSym} ${sign}${changePct.toFixed(1)}%`;
                bgColor = changePct >= 0 ? '#00aa00' : '#cc0000';
                pillWidth = 0.2;
            }

            pillBg.setAttribute('width', pillWidth);
            pillBg.setAttribute('color', bgColor);
            pillBg.setAttribute('position', `${currentX} -0.15 0.001`);

            pillText.setAttribute('value', label);
            pillText.setAttribute('position', `${pillWidth/2} 0.025 0.001`);
            pillBg.appendChild(pillText);
            itemContainer.appendChild(pillBg);

            const pillClickArea = document.createElement('a-plane');
            pillClickArea.setAttribute('width', pillWidth);
            pillClickArea.setAttribute('height', 0.05);
            pillClickArea.setAttribute('opacity', 0);
            pillClickArea.setAttribute('data-raycastable', '');
            pillClickArea.setAttribute('position', `${currentX + pillWidth / 2} -0.125 0.003`);
            pillClickArea.addEventListener('click', (e) => {
                e.stopPropagation();
                const scene = document.querySelector('a-scene');
                const tickerNewsEl = scene ? scene.querySelector('[ticker-news]') : null;
                if (tickerNewsEl && tickerNewsEl.components['ticker-news']) {
                    tickerNewsEl.components['ticker-news'].openTickerFromPill(cleanSym);
                }
            });
            itemContainer.appendChild(pillClickArea);

            currentX += pillWidth + 0.03;
        });

        const detailsBtn = document.createElement('a-entity');
        detailsBtn.setAttribute('position', `0.95 -0.18 0.002`);
        detailsBtn.setAttribute('ui-button', {
            label: 'Details',
            width: 0.22,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.01,
            preferredFontSize: 0.03
        });
        detailsBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openTrendingStockDetail(t);
        });
        itemContainer.appendChild(detailsBtn);

        const clickArea = document.createElement('a-plane');
        clickArea.setAttribute('width', 0.85);
        clickArea.setAttribute('height', 0.16);
        clickArea.setAttribute('material', 'transparent: true; opacity: 0; depthWrite: false;');
        clickArea.setAttribute('data-raycastable', '');
        clickArea.setAttribute('position', `0.425 -0.08 0.001`);
        clickArea.addEventListener('click', () => this.openTrendingStockDetail(t));
        clickArea.addEventListener('mouseenter', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: '#6C6CFF', dur: 200, easing: 'easeInOutQuad' });
        });
        clickArea.addEventListener('mouseleave', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: this.mainContentColor, dur: 200, easing: 'easeInOutQuad' });
        });
        itemContainer.appendChild(clickArea);

        this.contentElementS1.appendChild(itemContainer);
    },

    createArticleItem: function (a, y) {
        const itemContainer = document.createElement('a-entity');
        itemContainer.setAttribute('position', `0 ${y} 0.01`);

        const sourceName = a.publisher || 'Unknown';
        const dateStr = a.publishedDate ? new Date(a.publishedDate).toLocaleDateString() : '';

        const metaText = document.createElement('a-text');
        metaText.setAttribute('value', `${sourceName} • ${dateStr}`);
        metaText.setAttribute('color', this.mainContentColor);
        metaText.setAttribute('scale', '0.16 0.16 0.16');
        metaText.setAttribute('anchor', 'left');
        metaText.setAttribute('opacity', 0.6);
        metaText.setAttribute('position', `0 0 0.001`);
        itemContainer.appendChild(metaText);

        const titleElem = document.createElement('a-text');
        let rawTitle = this.decodeHtmlEntities(a.title || '');
        if (rawTitle.length > 52) {
            rawTitle = rawTitle.slice(0, 52) + '...';
        }
        titleElem.setAttribute('value', rawTitle);
        titleElem.setAttribute('color', this.mainContentColor);
        titleElem.setAttribute('scale', '0.23 0.23 0.23');
        titleElem.setAttribute('width', 3.5);
        titleElem.setAttribute('wrap-count', 28);
        titleElem.setAttribute('line-height', 60);
        titleElem.setAttribute('anchor', 'left');
        titleElem.setAttribute('baseline', 'top');
        titleElem.setAttribute('position', `0 -0.04 0.001`);
        itemContainer.appendChild(titleElem);

        let currentX = 0;
        const articleTickers = a.tickers || [];
        articleTickers.slice(0, 3).forEach(sym => {
            const cleanSym = String(sym).toUpperCase();
            const entry = this.priceMap ? this.priceMap.get(cleanSym) : null;
            const changePct = entry?.changePct ?? null;
            const isPreIpo = this.isPreIpoSymbol(cleanSym);

            const pillBg = document.createElement('a-rounded-plane');
            pillBg.setAttribute('height', 0.05);
            pillBg.setAttribute('radius', 0.008);

            const pillText = document.createElement('a-text');
            pillText.setAttribute('color', '#fff');
            pillText.setAttribute('scale', '0.12 0.12 0.12');
            pillText.setAttribute('align', 'center');
            pillText.setAttribute('baseline', 'center');

            let label = cleanSym;
            let bgColor = '#555555';
            let pillWidth = 0.12;

            if (isPreIpo) {
                label = `${cleanSym} (Pre-IPO)`;
                bgColor = '#444444';
                pillWidth = 0.22;
            } else if (changePct !== null) {
                const sign = changePct >= 0 ? '+' : '';
                label = `${cleanSym} ${sign}${changePct.toFixed(1)}%`;
                bgColor = changePct >= 0 ? '#00aa00' : '#cc0000';
                pillWidth = 0.2;
            }

            pillBg.setAttribute('width', pillWidth);
            pillBg.setAttribute('color', bgColor);
            pillBg.setAttribute('position', `${currentX} -0.205 0.001`);

            pillText.setAttribute('value', label);
            pillText.setAttribute('position', `${pillWidth/2} 0.025 0.001`);
            pillBg.appendChild(pillText);
            itemContainer.appendChild(pillBg);

            const pillClickArea = document.createElement('a-plane');
            pillClickArea.setAttribute('width', pillWidth);
            pillClickArea.setAttribute('height', 0.05);
            pillClickArea.setAttribute('opacity', 0);
            pillClickArea.setAttribute('data-raycastable', '');
            pillClickArea.setAttribute('position', `${currentX + pillWidth / 2} -0.18 0.003`);
            pillClickArea.addEventListener('click', (e) => {
                e.stopPropagation();
                const scene = document.querySelector('a-scene');
                const tickerNewsEl = scene ? scene.querySelector('[ticker-news]') : null;
                if (tickerNewsEl && tickerNewsEl.components['ticker-news']) {
                    tickerNewsEl.components['ticker-news'].openTickerFromPill(cleanSym);
                }
            });
            itemContainer.appendChild(pillClickArea);

            currentX += pillWidth + 0.03;
        });

        const detailsBtn = document.createElement('a-entity');
        detailsBtn.setAttribute('position', `0.95 -0.18 0.002`);
        detailsBtn.setAttribute('ui-button', {
            label: 'Read',
            width: 0.22,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.01,
            preferredFontSize: 0.03
        });
        detailsBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openArticleDetail(a);
        });
        itemContainer.appendChild(detailsBtn);

        const clickArea = document.createElement('a-plane');
        clickArea.setAttribute('width', 0.85);
        clickArea.setAttribute('height', 0.16);
        clickArea.setAttribute('material', 'transparent: true; opacity: 0; depthWrite: false;');
        clickArea.setAttribute('data-raycastable', '');
        clickArea.setAttribute('position', `0.425 -0.08 0.001`);
        clickArea.addEventListener('click', () => this.openArticleDetail(a));
        clickArea.addEventListener('mouseenter', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: '#6C6CFF', dur: 200, easing: 'easeInOutQuad' });
        });
        clickArea.addEventListener('mouseleave', () => {
            titleElem.setAttribute('animation__color', { property: 'color', to: this.mainContentColor, dur: 200, easing: 'easeInOutQuad' });
        });
        itemContainer.appendChild(clickArea);

        this.contentElementS1.appendChild(itemContainer);
    },

    renderPagination: function() {
        const existing = this.contentElementS1.querySelector('.pagination-controls');
        if (existing) existing.remove();

        if (this.totalPages <= 1) return;

        const container = document.createElement('a-entity');
        container.className = 'pagination-controls';
        container.setAttribute('position', `0.55 -1.28 0.02`);

        const btnWidth = 0.12;
        const btnHeight = 0.08;
        const btnGap = 0.22;
        const textColor = this.themeMode === 'Light' ? '#111' : '#fff';

        const prevBtn = document.createElement('a-entity');
        prevBtn.setAttribute('position', `${-btnGap} 0 0`);
        prevBtn.setAttribute('visible', this.currentPage > 0);
        prevBtn.setAttribute('ui-button', {
            label: '<',
            width: btnWidth,
            height: btnHeight,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.02,
            preferredFontSize: 0.04
        });
        prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.currentPage > 0) {
                this.currentPage--;
                this.renderCurrentPage();
            }
        });
        container.appendChild(prevBtn);

        const pageText = document.createElement('a-troika-text');
        pageText.setAttribute('value', `${this.currentPage + 1} / ${this.totalPages}`);
        pageText.setAttribute('align', 'center');
        pageText.setAttribute('color', textColor);
        pageText.setAttribute('font-size', '0.045');
        pageText.setAttribute('anchor', 'center');
        pageText.setAttribute('position', '0 0 0');
        container.appendChild(pageText);

        const nextBtn = document.createElement('a-entity');
        nextBtn.setAttribute('position', `${btnGap} 0 0`);
        nextBtn.setAttribute('visible', this.currentPage < this.totalPages - 1);
        nextBtn.setAttribute('ui-button', {
            label: '>',
            width: btnWidth,
            height: btnHeight,
            colorScheme: 'primary',
            type: 'rounded-box',
            radius: 0.01,
            depth: 0.02,
            preferredFontSize: 0.04
        });
        nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++;
                this.renderCurrentPage();
            }
        });
        container.appendChild(nextBtn);

        this.contentElementS1.appendChild(container);
    },

    renderSourcesPage: function(container, title, articleIds) {
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }

        const pageSize = 3;
        const totalPages = Math.max(1, Math.ceil(articleIds.length / pageSize));
        if (this.currentSourcesPage >= totalPages) this.currentSourcesPage = totalPages - 1;
        if (this.currentSourcesPage < 0) this.currentSourcesPage = 0;

        const startIndex = this.currentSourcesPage * pageSize;
        const pageIds = articleIds.slice(startIndex, startIndex + pageSize);

        const hasPagination = totalPages > 1;
        const panelBottom = hasPagination ? -1.40 : -1.50;

        const totalSourcesHeight = pageIds.length * 0.17;
        let sourceY = panelBottom + totalSourcesHeight - 0.17;
        const headerY = sourceY + 0.08;

        const sourcesHeader = document.createElement('a-text');
        sourcesHeader.setAttribute('value', title);
        sourcesHeader.setAttribute('color', this.mainContentColor);
        sourcesHeader.setAttribute('scale', '0.2 0.2 0.2');
        sourcesHeader.setAttribute('anchor', 'left');
        sourcesHeader.setAttribute('opacity', 0.7);
        sourcesHeader.setAttribute('position', `0 ${headerY} 0.001`);
        container.appendChild(sourcesHeader);

        const articles = this.rawPayload?.articles || {};
        pageIds.forEach(aid => {
            const a = articles[aid];
            if (!a) return;

            const sourceName = this.cleanSourceName(a.source, a.url);
            const dateStr = a.published_at ? new Date(a.published_at).toLocaleDateString() : '';

            const sContainer = document.createElement('a-entity');
            sContainer.setAttribute('position', `0 ${sourceY} 0.001`);

            const sMeta = document.createElement('a-text');
            sMeta.setAttribute('value', `${sourceName} • ${dateStr}`);
            sMeta.setAttribute('color', this.mainContentColor);
            sMeta.setAttribute('scale', '0.14 0.14 0.14');
            sMeta.setAttribute('anchor', 'left');
            sMeta.setAttribute('opacity', 0.6);
            sMeta.setAttribute('position', `0 0 0.001`);
            sContainer.appendChild(sMeta);

            const sTitle = document.createElement('a-text');
            const truncatedTitle = a.title.length > 55 ? a.title.slice(0, 52) + '...' : a.title;
            sTitle.setAttribute('value', this.decodeHtmlEntities(truncatedTitle));
            sTitle.setAttribute('color', this.mainContentColor);
            sTitle.setAttribute('scale', '0.19 0.19 0.19');
            sTitle.setAttribute('width', 4);
            sTitle.setAttribute('wrap-count', 30);
            sTitle.setAttribute('anchor', 'left');
            sTitle.setAttribute('baseline', 'top');
            sTitle.setAttribute('position', `0 -0.035 0.001`);
            sContainer.appendChild(sTitle);

            const sReadBtn = document.createElement('a-entity');
            sReadBtn.setAttribute('position', `0.95 -0.07 0.002`);
            sReadBtn.setAttribute('ui-button', {
                label: 'Read',
                width: 0.18,
                height: 0.06,
                colorScheme: 'primary',
                type: 'rounded-box',
                radius: 0.008,
                depth: 0.01,
                preferredFontSize: 0.025
            });
            sReadBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.openArticleDetail(a);
            });
            sContainer.appendChild(sReadBtn);

            const sClickArea = document.createElement('a-plane');
            sClickArea.setAttribute('width', 0.85);
            sClickArea.setAttribute('height', 0.12);
            sClickArea.setAttribute('material', 'transparent: true; opacity: 0; depthWrite: false;');
            sClickArea.setAttribute('data-raycastable', '');
            sClickArea.setAttribute('position', `0.425 -0.06 0.001`);
            sClickArea.addEventListener('click', () => this.openArticleDetail(a));
            sClickArea.addEventListener('mouseenter', () => {
                sTitle.setAttribute('animation__color', { property: 'color', to: '#6C6CFF', dur: 200, easing: 'easeInOutQuad' });
            });
            sClickArea.addEventListener('mouseleave', () => {
                sTitle.setAttribute('animation__color', { property: 'color', to: this.mainContentColor, dur: 200, easing: 'easeInOutQuad' });
            });
            sContainer.appendChild(sClickArea);

            container.appendChild(sContainer);
            sourceY -= 0.17;
        });

        if (hasPagination) {
            const pageContainer = document.createElement('a-entity');
            pageContainer.setAttribute('position', `0.55 -1.55 0.001`);

            const btnWidth = 0.1;
            const btnHeight = 0.06;
            const btnGap = 0.2;
            const textColor = this.themeMode === 'Light' ? '#111' : '#fff';

            const prevBtn = document.createElement('a-entity');
            prevBtn.setAttribute('position', `${-btnGap} 0 0`);
            prevBtn.setAttribute('visible', this.currentSourcesPage > 0);
            prevBtn.setAttribute('ui-button', {
                label: '<', width: btnWidth, height: btnHeight, colorScheme: 'primary', type: 'rounded-box', radius: 0.01, depth: 0.02, preferredFontSize: 0.03
            });
            prevBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.currentSourcesPage > 0) {
                    this.currentSourcesPage--;
                    this.renderSourcesPage(container, title, articleIds);
                }
            });
            pageContainer.appendChild(prevBtn);

            const pageText = document.createElement('a-troika-text');
            pageText.setAttribute('value', `${this.currentSourcesPage + 1} / ${totalPages}`);
            pageText.setAttribute('align', 'center');
            pageText.setAttribute('color', textColor);
            pageText.setAttribute('font-size', '0.035');
            pageText.setAttribute('anchor', 'center');
            pageText.setAttribute('position', `0 0 0`);
            pageContainer.appendChild(pageText);

            const nextBtn = document.createElement('a-entity');
            nextBtn.setAttribute('position', `${btnGap} 0 0`);
            nextBtn.setAttribute('visible', this.currentSourcesPage < totalPages - 1);
            nextBtn.setAttribute('ui-button', {
                label: '>', width: btnWidth, height: btnHeight, colorScheme: 'primary', type: 'rounded-box', radius: 0.01, depth: 0.02, preferredFontSize: 0.03
            });
            nextBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.currentSourcesPage < totalPages - 1) {
                    this.currentSourcesPage++;
                    this.renderSourcesPage(container, title, articleIds);
                }
            });
            pageContainer.appendChild(nextBtn);

            container.appendChild(pageContainer);
        }
    },

    openArticleDetail: function (a) {
        this.screen1.setAttribute('visible', 'false');
        this.screen1.setAttribute('position', '0 6 0');
        this.screen2.setAttribute('visible', 'true');
        this.screen2.setAttribute('position', '0 0 0.04');

        while (this.contentElementS2.children.length > 0) {
            this.contentElementS2.removeChild(this.contentElementS2.firstChild);
        }

        const categoryVal = this.tickerSymbol || (a.tickers && a.tickers.length > 0 ? a.tickers[0] : 'NEWS');
        const typeEl = document.createElement('a-text');
        typeEl.setAttribute('value', categoryVal.toUpperCase());
        typeEl.setAttribute('color', this.mainContentColor);
        typeEl.setAttribute('scale', '0.15 0.15 0.15');
        typeEl.setAttribute('anchor', 'left');
        typeEl.setAttribute('opacity', 0.5);
        typeEl.setAttribute('position', `0 -0.05 0.001`);
        this.contentElementS2.appendChild(typeEl);

        const dateVal = a.publishedDate ? new Date(a.publishedDate).toLocaleDateString() : (a.published_at ? new Date(a.published_at).toLocaleDateString() : '');
        const dateEl = document.createElement('a-text');
        dateEl.setAttribute('value', dateVal);
        dateEl.setAttribute('color', this.mainContentColor);
        dateEl.setAttribute('scale', '0.15 0.15 0.15');
        dateEl.setAttribute('anchor', 'right');
        dateEl.setAttribute('align', 'right');
        dateEl.setAttribute('opacity', 0.5);
        dateEl.setAttribute('position', `1.1 -0.05 0.001`);
        this.contentElementS2.appendChild(dateEl);

        const titleEl = document.createElement('a-text');
        titleEl.setAttribute('value', this.decodeHtmlEntities(a.title || ''));
        titleEl.setAttribute('color', this.mainContentColor);
        titleEl.setAttribute('font-size', 0.05);
        titleEl.setAttribute('scale', '0.25 0.25 0.25');
        titleEl.setAttribute('anchor', 'left');
        titleEl.setAttribute('baseline', 'top');
        titleEl.setAttribute('position', `0 -0.1 0.001`);
        titleEl.setAttribute('width', 4.2);
        titleEl.setAttribute('wrapCount', 33.6);
        titleEl.setAttribute('line-height', 60);
        this.contentElementS2.appendChild(titleEl);

        const sourceVal = a.publisher || this.cleanSourceName(a.source, a.url);
        const sourceEl = document.createElement('a-text');
        sourceEl.setAttribute('value', `By ${this.decodeHtmlEntities(sourceVal)}`);
        sourceEl.setAttribute('font-size', 0.04);
        sourceEl.setAttribute('scale', '0.2 0.2 0.2');
        sourceEl.setAttribute('anchor', 'left');
        sourceEl.setAttribute('baseline', 'top');
        sourceEl.setAttribute('opacity', 0.5);
        sourceEl.setAttribute('position', `0 -0.36 0.001`);
        this.contentElementS2.appendChild(sourceEl);

        const descText = a.description || a.text || '';
        const finalDescription = descText.length > 400
            ? descText.slice(0, descText.lastIndexOf(' ', 400)) + "..."
            : descText;
        const descriptionEl = document.createElement('a-text');
        descriptionEl.setAttribute('value', this.decodeHtmlEntities(finalDescription));
        descriptionEl.setAttribute('color', this.mainContentColor);
        descriptionEl.setAttribute('font-size', 0.05);
        descriptionEl.setAttribute('scale', '0.25 0.25 0.25');
        descriptionEl.setAttribute('anchor', 'left');
        descriptionEl.setAttribute('baseline', 'top');
        descriptionEl.setAttribute('position', `0 -0.48 0.001`);
        descriptionEl.setAttribute('width', 4.2);
        descriptionEl.setAttribute('wrapCount', 33.6);
        descriptionEl.setAttribute('line-height', 60);
        this.contentElementS2.appendChild(descriptionEl);

        const reedFullArticleContainer = document.createElement('a-entity');
        reedFullArticleContainer.setAttribute('position', `0.55 -1.55 0.0`);

        const reedFullArticleButton = document.createElement('ui-button');
        reedFullArticleButton.setAttribute('label', 'Read full article');
        reedFullArticleButton.setAttribute('type', 'rounded-box');
        reedFullArticleButton.setAttribute('width', 1.1);
        reedFullArticleButton.setAttribute('height', 0.14);
        reedFullArticleButton.setAttribute('depth', 0.01);
        reedFullArticleButton.setAttribute('radius', 0.02);
        reedFullArticleButton.setAttribute('color-scheme', 'accent');
        reedFullArticleButton.setAttribute('preferred-font-size', 0.04);
        reedFullArticleButton.setAttribute('hover-scale', 1);
        reedFullArticleContainer.appendChild(reedFullArticleButton);

        this.currentNews = a;
        reedFullArticleButton.addEventListener('click', () => {
            if (!this.currentNews || !this.currentNews.url) return;
            const scene = document.querySelector('a-scene');
            if (scene && scene.exitVR) {
                scene.exitVR();
            }
            if (window.gtag) gtag('event', 'VR_LeftPanel_ClickOnNewsReadFull');
            window.open(this.currentNews.url);
        });

        this.contentElementS2.appendChild(reedFullArticleContainer);
    },

    openNarrativeDetail: function (n) {
        this.screen1.setAttribute('visible', 'false');
        this.screen1.setAttribute('position', '0 6 0');
        this.screen2.setAttribute('visible', 'true');
        this.screen2.setAttribute('position', '0 0 0.04');

        while (this.contentElementS2.children.length > 0) {
            this.contentElementS2.removeChild(this.contentElementS2.firstChild);
        }

        let rawTitle = this.decodeHtmlEntities(n.title || '');
        if (rawTitle.length > 35) rawTitle = rawTitle.slice(0, 32) + '...';
        const titleText = document.createElement('a-text');
        titleText.setAttribute('value', rawTitle);
        titleText.setAttribute('color', this.mainContentColor);
        titleText.setAttribute('scale', '0.23 0.23 0.23');
        titleText.setAttribute('width', 4.5);
        titleText.setAttribute('wrap-count', 35);
        titleText.setAttribute('line-height', 60);
        titleText.setAttribute('anchor', 'left');
        titleText.setAttribute('baseline', 'top');
        titleText.setAttribute('position', `0 -0.02 0.001`);
        this.contentElementS2.appendChild(titleText);

        const dir = (n.direction || 'neutral').toLowerCase();
        const dirLabel = dir.charAt(0).toUpperCase() + dir.slice(1);
        const badgeBg = document.createElement('a-rounded-plane');
        badgeBg.setAttribute('width', 0.16);
        badgeBg.setAttribute('height', 0.06);
        badgeBg.setAttribute('radius', 0.01);
        const badgeColor = dir === 'bullish' || dir === 'positive' || dir === 'up' ? '#00aa00'
                         : dir === 'bearish' || dir === 'negative' || dir === 'down' ? '#cc0000'
                         : '#555555';
        badgeBg.setAttribute('color', badgeColor);
        badgeBg.setAttribute('position', `0 -0.18 0.001`);
        
        const badgeText = document.createElement('a-text');
        badgeText.setAttribute('value', dirLabel);
        badgeText.setAttribute('color', '#fff');
        badgeText.setAttribute('scale', '0.15 0.15 0.15');
        badgeText.setAttribute('align', 'center');
        badgeText.setAttribute('baseline', 'center');
        badgeText.setAttribute('position', `0.08 0.03 0.001`);
        badgeBg.appendChild(badgeText);
        this.contentElementS2.appendChild(badgeBg);

        const isInflection = n.freshness && n.freshness.status === 'inflection';
        if (isInflection) {
            const infBg = document.createElement('a-rounded-plane');
            infBg.setAttribute('width', 0.22);
            infBg.setAttribute('height', 0.06);
            infBg.setAttribute('radius', 0.01);
            infBg.setAttribute('color', '#ff9f00');
            infBg.setAttribute('position', `0.19 -0.18 0.001`);
            
            const infText = document.createElement('a-text');
            infText.setAttribute('value', 'Inflection');
            infText.setAttribute('color', '#fff');
            infText.setAttribute('scale', '0.15 0.15 0.15');
            infText.setAttribute('align', 'center');
            infText.setAttribute('baseline', 'center');
            infText.setAttribute('position', `0.11 0.03 0.001`);
            infBg.appendChild(infText);
            this.contentElementS2.appendChild(infBg);
        }

        const count = n.article_count || 0;
        const countText = document.createElement('a-text');
        countText.setAttribute('value', `${count} source${count !== 1 ? 's' : ''}`);
        countText.setAttribute('color', this.mainContentColor);
        countText.setAttribute('scale', '0.18 0.18 0.18');
        countText.setAttribute('anchor', 'left');
        countText.setAttribute('opacity', 0.6);
        countText.setAttribute('position', `${isInflection ? 0.44 : 0.20} -0.15 0.001`);
        this.contentElementS2.appendChild(countText);

        let currentX = 0;
        const assets = [...(n.tickers || []), ...(n.affected_assets || [])];
        assets.slice(0, 3).forEach(sym => {
            const cleanSym = String(sym).toUpperCase();
            const entry = this.priceMap ? this.priceMap.get(cleanSym) : null;
            const changePct = entry?.changePct ?? null;
            const isPreIpo = this.isPreIpoSymbol(cleanSym);

            const pillBg = document.createElement('a-rounded-plane');
            pillBg.setAttribute('height', 0.05);
            pillBg.setAttribute('radius', 0.008);

            const pillText = document.createElement('a-text');
            pillText.setAttribute('color', '#fff');
            pillText.setAttribute('scale', '0.12 0.12 0.12');
            pillText.setAttribute('align', 'center');
            pillText.setAttribute('baseline', 'center');

            let label = cleanSym;
            let bgColor = '#555555';
            let pillWidth = 0.12;

            if (isPreIpo) {
                label = `${cleanSym} (Pre-IPO)`;
                bgColor = '#444444';
                pillWidth = 0.22;
            } else if (changePct !== null) {
                const sign = changePct >= 0 ? '+' : '';
                label = `${cleanSym} ${sign}${changePct.toFixed(1)}%`;
                bgColor = changePct >= 0 ? '#00aa00' : '#cc0000';
                pillWidth = 0.2;
            }

            pillBg.setAttribute('width', pillWidth);
            pillBg.setAttribute('color', bgColor);
            pillBg.setAttribute('position', `${currentX} -0.255 0.001`);

            pillText.setAttribute('value', label);
            pillText.setAttribute('position', `${pillWidth/2} 0.025 0.001`);
            pillBg.appendChild(pillText);
            this.contentElementS2.appendChild(pillBg);

            // Make pill clickable to open its stock chart
            const pillClickArea = document.createElement('a-plane');
            pillClickArea.setAttribute('width', pillWidth);
            pillClickArea.setAttribute('height', 0.05);
            pillClickArea.setAttribute('opacity', 0);
            pillClickArea.setAttribute('data-raycastable', '');
            pillClickArea.setAttribute('position', `${currentX + pillWidth/2} -0.23 0.003`);
            pillClickArea.addEventListener('click', () => {
                const scene = document.querySelector('a-scene');
                const tickerNewsEl = scene ? scene.querySelector('[ticker-news]') : null;
                if (tickerNewsEl && tickerNewsEl.components['ticker-news']) {
                    tickerNewsEl.components['ticker-news'].openTickerFromPill(cleanSym);
                }
            });
            this.contentElementS2.appendChild(pillClickArea);

            currentX += pillWidth + 0.03;
        });

        const rawSummary = this.decodeHtmlEntities(n.summary || '');
        const estimatedLines = Math.ceil(rawSummary.length / 28);
        const cardHeight = Math.max(0.1, estimatedLines * 0.035 + 0.05);

        const summaryCard = document.createElement('a-rounded-plane');
        summaryCard.setAttribute('width', 1.05);
        summaryCard.setAttribute('height', cardHeight);
        summaryCard.setAttribute('radius', 0.015);
        summaryCard.setAttribute('color', this.themeMode === 'Dark' ? '#222' : '#ddd');
        summaryCard.setAttribute('position', `0.025 ${-0.32 - cardHeight} 0.001`);

        const summaryText = document.createElement('a-text');
        summaryText.setAttribute('value', rawSummary);
        summaryText.setAttribute('color', this.mainContentColor);
        summaryText.setAttribute('scale', '0.2 0.2 0.2');
        summaryText.setAttribute('width', 4.5);
        summaryText.setAttribute('wrap-count', 32);
        summaryText.setAttribute('align', 'left');
        summaryText.setAttribute('baseline', 'top');
        summaryText.setAttribute('position', `0.025 ${cardHeight - 0.02} 0.001`);
        summaryCard.appendChild(summaryText);
        this.contentElementS2.appendChild(summaryCard);

        const articleIds = n.article_ids || [];
        this.currentSourcesPage = 0;
        const sourcesContainer = document.createElement('a-entity');
        this.contentElementS2.appendChild(sourcesContainer);
        this.renderSourcesPage(sourcesContainer, 'Sources', articleIds);
    },

    openTrendingStockDetail: function (t) {
        this.screen1.setAttribute('visible', 'false');
        this.screen1.setAttribute('position', '0 6 0');
        this.screen2.setAttribute('visible', 'true');
        this.screen2.setAttribute('position', '0 0 0.04');

        while (this.contentElementS2.children.length > 0) {
            this.contentElementS2.removeChild(this.contentElementS2.firstChild);
        }

        const syms = t.grouped_tickers || [t.symbol];
        const symbolsDisplay = syms.length <= 3 ? syms.join(' + ') : `${syms.slice(0, 2).join(' + ')} +${syms.length - 2}`;

        const nameVal = (t.group_label || t.name || t.symbol || '');
        let titleVal = `${nameVal} (${symbolsDisplay})`;
        titleVal = this.decodeHtmlEntities(titleVal);
        if (titleVal.length > 35) titleVal = titleVal.slice(0, 32) + '...';

        const titleText = document.createElement('a-text');
        titleText.setAttribute('value', titleVal);
        titleText.setAttribute('color', this.mainContentColor);
        titleText.setAttribute('scale', '0.23 0.23 0.23');
        titleText.setAttribute('width', 4.5);
        titleText.setAttribute('wrap-count', 35);
        titleText.setAttribute('line-height', 60);
        titleText.setAttribute('anchor', 'left');
        titleText.setAttribute('baseline', 'top');
        titleText.setAttribute('position', `0 -0.02 0.001`);
        this.contentElementS2.appendChild(titleText);

        let currentX = 0;
        syms.forEach(sym => {
            const cleanSym = String(sym).toUpperCase();
            const entry = this.priceMap ? this.priceMap.get(cleanSym) : null;
            const changePct = entry?.changePct ?? null;
            const isPreIpo = this.isPreIpoSymbol(cleanSym);

            const cardBg = document.createElement('a-rounded-plane');
            cardBg.setAttribute('height', 0.08);
            cardBg.setAttribute('radius', 0.01);
            cardBg.setAttribute('color', this.themeMode === 'Dark' ? '#222' : '#ddd');

            const cardText = document.createElement('a-text');
            cardText.setAttribute('color', this.mainContentColor);
            cardText.setAttribute('scale', '0.14 0.14 0.14');
            cardText.setAttribute('align', 'center');
            cardText.setAttribute('baseline', 'center');

            let label = cleanSym;
            let cardWidth = 0.16;

            if (isPreIpo) {
                label = `${cleanSym}\nPre-IPO`;
                cardWidth = 0.22;
            } else if (changePct !== null) {
                const sign = changePct >= 0 ? '+' : '';
                label = `${cleanSym}\n${sign}${changePct.toFixed(2)}%`;
                cardText.setAttribute('color', changePct >= 0 ? '#00aa00' : '#cc0000');
                cardWidth = 0.18;
            }

            cardBg.setAttribute('width', cardWidth);
            cardBg.setAttribute('position', `${currentX} -0.19 0.001`);

            cardText.setAttribute('value', label);
            cardText.setAttribute('position', `${cardWidth/2} 0.04 0.001`);
            cardBg.appendChild(cardText);
            this.contentElementS2.appendChild(cardBg);

            const cardClickArea = document.createElement('a-plane');
            cardClickArea.setAttribute('width', cardWidth);
            cardClickArea.setAttribute('height', 0.08);
            cardClickArea.setAttribute('material', 'transparent: true; opacity: 0; depthWrite: false;');
            cardClickArea.setAttribute('data-raycastable', '');
            cardClickArea.setAttribute('position', `${currentX + cardWidth/2} -0.15 0.003`);
            cardClickArea.addEventListener('click', () => {
                const scene = document.querySelector('a-scene');
                const tickerNewsEl = scene ? scene.querySelector('[ticker-news]') : null;
                if (tickerNewsEl && tickerNewsEl.components['ticker-news']) {
                    tickerNewsEl.components['ticker-news'].openTickerFromPill(cleanSym);
                }
            });
            this.contentElementS2.appendChild(cardClickArea);

            currentX += cardWidth + 0.03;
        });

        const desc = this.getTrendingStockDescription(t);
        if (desc) {
            const rawSummary = this.decodeHtmlEntities(desc);
            const estimatedLines = Math.ceil(rawSummary.length / 28);
            const cardHeight = Math.max(0.1, estimatedLines * 0.035 + 0.05);

            const summaryCard = document.createElement('a-rounded-plane');
            summaryCard.setAttribute('width', 1.05);
            summaryCard.setAttribute('height', cardHeight);
            summaryCard.setAttribute('radius', 0.015);
            summaryCard.setAttribute('color', this.themeMode === 'Dark' ? '#222' : '#ddd');
            summaryCard.setAttribute('position', `0.025 ${-0.32 - cardHeight} 0.001`);

            const summaryText = document.createElement('a-text');
            summaryText.setAttribute('value', rawSummary);
            summaryText.setAttribute('color', this.mainContentColor);
            summaryText.setAttribute('scale', '0.2 0.2 0.2');
            summaryText.setAttribute('width', 4.5);
            summaryText.setAttribute('wrap-count', 32);
            summaryText.setAttribute('align', 'left');
            summaryText.setAttribute('baseline', 'top');
            summaryText.setAttribute('position', `0.025 ${cardHeight - 0.02} 0.001`);
            summaryCard.appendChild(summaryText);
            this.contentElementS2.appendChild(summaryCard);
        }

        const articleIds = t.article_ids || [];
        this.currentSourcesPage = 0;
        const sourcesContainer = document.createElement('a-entity');
        this.contentElementS2.appendChild(sourcesContainer);
        this.renderSourcesPage(sourcesContainer, `Articles (${t.article_count || 0})`, articleIds);
    },

    getTrendingStockDescription: function (t) {
        const syms = t.grouped_tickers || [t.symbol];
        const narratives = this.rawPayload?.narratives || [];
        const articles = this.rawPayload?.articles || {};

        const narrative = narratives.find(n => {
            const nSyms = [...(n.tickers || []), ...(n.affected_assets || [])].map(s => String(s).toUpperCase());
            return syms.some(sym => nSyms.includes(String(sym).toUpperCase()));
        });
        if (narrative && narrative.summary) {
            return narrative.summary;
        }

        for (const aid of (t.article_ids || [])) {
            const a = articles[aid];
            if (a && a.text && a.text.length > 40) {
                return a.text;
            }
        }
        return '';
    },

    isPreIpoSymbol: function(symbol) {
        if (!this.rawPayload?.tickers) return false;
        const cleanSym = String(symbol || '').toUpperCase().trim();
        return this.rawPayload.tickers.some(t => t.possible_pre_ipo === true && String(t.symbol || '').toUpperCase().trim() === cleanSym);
    },

    cleanSourceName: function(source, url) {
        let name = source || '';
        const isGeneric = !name || 
            name.toLowerCase().includes('stocknewsapi') || 
            name.toLowerCase().includes('fmp_') || 
            name.toLowerCase().includes('mediastack') ||
            name.toLowerCase() === 'lulegacy';
            
        if (isGeneric && url) {
            try {
                const hostname = url.split('/')[2] || '';
                let host = hostname.toLowerCase();
                if (host.startsWith('www.')) host = host.slice(4);
                
                const domainMap = {
                    'marketwatch.com': 'MarketWatch',
                    'wsj.com': 'Wall Street Journal',
                    'seekingalpha.com': 'Seeking Alpha',
                    'bloomberg.com': 'Bloomberg',
                    'reuters.com': 'Reuters',
                    'cnbc.com': 'CNBC',
                    'globenewswire.com': 'GlobeNewswire',
                    'prnewswire.com': 'PR Newswire',
                    'businesswire.com': 'Business Wire',
                    'fool.com': 'The Motley Fool',
                    'investorplace.com': 'InvestorPlace',
                    'barrons.com': 'Barrons',
                    'thestreet.com': 'The Street',
                    'techcrunch.com': 'TechCrunch',
                    'foxbusiness.com': 'Fox Business',
                    'marketbeat.com': 'MarketBeat',
                    'investopedia.com': 'Investopedia',
                    'nytimes.com': 'New York Times',
                    'forbes.com': 'Forbes',
                    'businessinsider.com': 'Business Insider'
                };
                
                if (domainMap[host]) {
                    return domainMap[host];
                }
                
                const parts = host.split('.');
                if (parts.length >= 2) {
                    const domainName = parts[parts.length - 2];
                    return domainName.charAt(0).toUpperCase() + domainName.slice(1);
                }
                return host;
            } catch (e) {}
        }
        
        if (name === 'stocknewsapi_general') return 'General News';
        if (name.startsWith('fmp_')) return 'Financial News';
        if (name === 'mediastack_business') return 'Mediastack';
        
        return name || 'Unknown';
    },

    decodeHtmlEntities: function (str) {
        if (!str) return '';
        const parser = new DOMParser();
        const decoded = parser.parseFromString(str, "text/html");
        return decoded.documentElement.textContent;
    },

    updateTheme: function (e) {
        if (!e || !e.detail) return;
        this.themeMode = e.detail.themeMode;
        this.applyTheme();

        this.headerElementS1.replaceChildren();
        this.headerElementS2.replaceChildren();
        this.contentElementS1.replaceChildren();
        this.contentElementS2.replaceChildren();
        this.createNewsPanel();

        this.titleTextS1 = document.createElement('a-text');
        this.titleTextS1.setAttribute('value', 'News');
        this.titleTextS1.setAttribute('color', this.mainContentColor);
        this.titleTextS1.setAttribute('scale', '0.25 0.25 0.25');
        this.titleTextS1.setAttribute('anchor', 'left');
        this.titleTextS1.setAttribute('position', `0 0 0.01`);
        this.contentElementS1.appendChild(this.titleTextS1);

        const tickerNewsEl = this.el.sceneEl.querySelector('[ticker-news]');
        const currentFilter = tickerNewsEl ? tickerNewsEl.components['ticker-news']?.currentMode : 'market-summary';
        this.setFilter(currentFilter || 'market-summary');

        this.renderCurrentPage();
    },

    setFilter: function(filter) {
        const buttons = {
            'market-summary': this.marketSummaryBtn,
            'business-headlines': this.businessHeadlinesBtn,
            'trending-stock': this.trendingStockBtn,
            'watchlist-news': this.watchlistNewsBtn
        };
        for (const [key, btn] of Object.entries(buttons)) {
            if (btn) {
                btn.setAttribute('ui-button', 'selected', key === filter);
            }
        }
    }
});
